import React from "react";
import SignupForm from "@/components/auth/SignupForm";
import { Helmet } from 'react-helmet-async';

const SignupGuest: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Sign Up as a Guest | SaunaDip</title>
        <meta name="description" content="Join the SaunaDip community as a guest to book unique sauna experiences." />
      </Helmet>
      <div className="py-8 flex flex-col items-center">
        <h2 className="text-3xl font-bold text-sauna-navy mb-2">Sign Up as a Guest</h2>
        <p className="text-sauna-navy/70 mb-6 text-lg text-center max-w-md">Create a personal account to discover and book sauna experiences.</p>
        <SignupForm role="guest" />
      </div>
    </>
  );
};

export default SignupGuest; 